import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
const root = {}
export default root
root.name = 'processOne';
root.props = {processData: Object, deptDatas: Array, userDatas: Array, thisId: Number, success: Function};
root.data = {
	dangerGovernData:{
		cacheData:{},
		
	}
}
root.created = function() {
}
root.methods = {
	
	//发起审核
	startApproval: function(){
		const that = this;
		const formData = new FormData();
		formData.append("rectifierId", this.dangerGovernData.cacheData.rectifierId);
		formData.append("investFunds", parseInt(this.dangerGovernData.cacheData.investFunds));
		formData.append("rectifyDepId", this.dangerGovernData.cacheData.rectifyDepId);
		formData.append("hiddenGovernId", this.processData.id);
		formData.append("specificPlan", this.dangerGovernData.cacheData.specificPlan);
		formData.append("status", 0);
		if(this.processData.approveInfoVo == null){
			this.componentsMoudel.startPost('/approveInfo/save', formData, true).then(res => {
				that.success(that.processData, 1);
			})
		}else{
			formData.append("id", this.processData.approveInfoVo.id);
			this.componentsMoudel.startPost('/approveInfo/update', formData, true).then(res => {
				that.success(that.processData, 1);
			})
		}
		
	}
	
}
root.watch = {
	processData: function(newProcessData , oldProcessData){
		if(newProcessData.approveInfoVo && newProcessData.approveInfoVo !== null){
			this.dangerGovernData.cacheData = this.processData.approveInfoVo;
		}
		this.dangerGovernData.cacheData.rectifierId = newProcessData.rectifierId;
	}
}

FactoryComponents.initComponent(root);